import SubmissionPane from './SubmissionPane';

export default SubmissionPane;
